var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlayBig = function SvgPlayBig(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2338 8.42375C18.5671 9.19355 18.5671 11.1181 17.2338 11.8879L3.61688 19.7496C2.28355 20.5194 0.616881 19.5571 0.616881 18.0175L0.616882 2.29409C0.616882 0.754493 2.28355 -0.20776 3.61688 0.56204L17.2338 8.42375Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/assets/play-big.svg";